import { defineComponent as a, openBlock as l, createBlock as n, unref as r, mergeProps as p, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ a({
  name: "IconFloat",
  __name: "IconFloat",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (s, e) => (l(), n(r(i), p(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.22 8.22 0 0 1 1.91-5.28l2.493 2.493A4.73 4.73 0 0 0 7.25 12a4.73 4.73 0 0 0 .903 2.787L5.66 17.279A8.22 8.22 0 0 1 3.75 12m2.97 6.34A8.22 8.22 0 0 0 12 20.25a8.22 8.22 0 0 0 5.28-1.91l-2.494-2.493A4.73 4.73 0 0 1 12 16.75a4.73 4.73 0 0 1-2.787-.903L6.721 18.34M9.214 8.153 6.721 5.66A8.22 8.22 0 0 1 12 3.75a8.22 8.22 0 0 1 5.28 1.91l-2.494 2.493A4.73 4.73 0 0 0 12 7.25a4.73 4.73 0 0 0-2.787.903m6.634 1.06A4.73 4.73 0 0 1 16.75 12a4.73 4.73 0 0 1-.903 2.787l2.493 2.492A8.22 8.22 0 0 0 20.25 12a8.22 8.22 0 0 0-1.91-5.28l-2.493 2.493M8.75 12a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
